import { formatDateTime, DATE_FORMATS } from '@belong/common';
import { Text } from '@belong/ui';
import type { MoveInScheduleModel } from 'api/models';
import { formatString } from 'strings';
import { POST_INSPECTION_FLOW_STRINGS } from 'strings/post-inspection-flow';

type Props = {
  moveInSchedule?: MoveInScheduleModel;
  hideWhenUnleased?: boolean;
};

export function MoveInScheduleLine({
  moveInSchedule,
  hideWhenUnleased = false,
}: Props) {
  if (!moveInSchedule) return null;

  const { isLeaseSigned, moveInOn, approveBy } = moveInSchedule;

  if (!isLeaseSigned) {
    if (hideWhenUnleased) return null;

    return (
      <Text variant="p1" className="text-center">
        {POST_INSPECTION_FLOW_STRINGS['move_in_schedule.unleased']}
      </Text>
    );
  }

  if (!moveInOn || !approveBy) return null;

  return (
    <Text variant="p1" className="text-center">
      {formatString(POST_INSPECTION_FLOW_STRINGS['move_in_schedule.leased'], {
        moveInOn: formatDateTime({
          dateTime: moveInOn,
          format: DATE_FORMATS.MONTH_DAY_SHORT,
        }),
        approveBy: formatDateTime({
          dateTime: approveBy,
          format: DATE_FORMATS.MONTH_DAY_SHORT,
        }),
      })}
    </Text>
  );
}
